import { IDeductionChip, STAGE_ICONS, StageKey } from "./IDeductionChips";
import { getProgressChipClassName } from "./DeductionChipUtils";
import { cn } from "@/infrastructure/adapters/classnames";
import { DeductionChip } from "./DeductionChip";
import { useDeductionEdit } from "../../hooks/deduction";
import { IStyles } from "@/core/entities/lookup";

interface ProgressChipProps extends IDeductionChip {
  stageKey?: string;
  stageName?: string;
  statusKey?: string;
  statusName?: string;
}

export const ProgressChip = ({
  stageKey,
  stageName,
  statusKey,
  statusName,
  shape,
  withBorder = true,
  withIcon = true,
  withBackground = false,
  size = "small",
  style,
  className,
}: ProgressChipProps) => {
  const {stages} = useDeductionEdit();
  const selectedStyles = stages.data.find(stage => stage.stageKey === statusKey)?.styles;
  if (!statusName) return null;
  const icon = STAGE_ICONS[stageKey as StageKey];
  const classNames = cn(getProgressChipClassName(selectedStyles as IStyles, withBorder, withBackground), "progress-chip", className);

  return (
    <DeductionChip
      icon={withIcon && icon ? icon : undefined}
      label={statusName}
      ariaLabel={stageName}
      shape={shape}
      size={size}
      style={style}
      className={classNames}
    />
  );
};
